import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { ProvideAuth } from './hooks/useAuth'
import { ProvideConversation } from './hooks/useConversation'
import { LanguageProvider } from './util/LanguageContext'
import { VersionProvider } from './util/VersionContext'

// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ProvideAuth>
      <ProvideConversation>
        <LanguageProvider>
          <VersionProvider>
            <App />
          </VersionProvider>
        </LanguageProvider>
      </ProvideConversation>
    </ProvideAuth>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
